import script from "./contact_details.vue?vue&type=script&setup=true&lang=ts"
export * from "./contact_details.vue?vue&type=script&setup=true&lang=ts"

import "./contact_details.vue?vue&type=style&index=0&id=6860d21a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6860d21a"]])

export default __exports__